import { FaReact, FaNodeJs, FaServer, FaLayerGroup } from "react-icons/fa";
import { SiPostgresql, SiJavascript, SiCplusplus } from "react-icons/si";

export const skillTreeData = [
    {
        category: "Root Core Engineering",
        tag: "TIER 01 - FOUNDATION",
        skills: [
            {
                id: "cpp",
                title: "C++ & Computational Logic",
                icon: <SiCplusplus />,
                desc: "Algorithmic problem solving, data structures, and performance optimization.",
                specs: ["Memory Management", "Algorithms", "Physics Calculations"],
                link: "https://isocpp.org/"
            },
            {
                id: "js",
                title: "Modern JavaScript (ES6+)",
                icon: <SiJavascript />,
                desc: "Asynchronous programming, event-driven flows, and modern JS syntax.",
                specs: ["DOM & Async/Await", "Event Loops", "Clean Code Standards"],
                link: "https://developer.mozilla.org/"
            }
        ]
    },
    {
        category: "Full-Stack Development Branch",
        tag: "TIER 02 - CORE SYSTEMS",
        skills: [
            {
                id: "react",
                title: "Frontend Architecture (React)",
                icon: <FaReact />,
                desc: "Scalable component trees, state management, and modern UI integration.",
                specs: ["React Hooks", "UI Component Libraries", "Responsive Layouts"],
                link: "https://react.dev/"
            },
            {
                id: "node",
                title: "Backend API (Node.js & Express)",
                icon: <FaNodeJs />,
                desc: "RESTful endpoints, middleware, authentication, and service business logic.",
                specs: ["Express.js Routing", "JWT Auth", "REST API Design"],
                link: "https://nodejs.org/"
            },
            {
                id: "postgres",
                title: "Relational Data (PostgreSQL)",
                icon: <SiPostgresql />,
                desc: "Relational database schema modeling, queries, and data pipelines.",
                specs: ["Schema Architecture", "SQL Queries", "Data Integrity"],
                link: "https://www.postgresql.org/"
            }
        ]
    },
    {
        category: "Enterprise Solutions & Refactoring",
        tag: "TIER 03 - PRODUCTION DEPLOYMENT",
        skills: [
            {
                id: "refactor",
                title: "Codebase Refactoring & Maintenance",
                icon: <FaServer />,
                desc: "Improving legacy codebases, lowering technical debt, and system optimization.",
                specs: ["Code Audits", "Performance Tuning", "Modular Design"],
                link: "https://refactoring.guru/"
            },
            {
                id: "fullstack",
                title: "End-to-End Business Systems",
                icon: <FaLayerGroup />,
                desc: "Delivering fully integrated web platforms with payment & dynamic client features.",
                specs: ["Payment Integrations", "Interactive Maps", "Admin Portals"],
                link: "https://github.com"
            }
        ]
    }
];